var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraidentSubscription1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 701,
    viewBox: "0 0 1440 701",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8765_16803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1152.29 692.397L1142.6 574.205C762.033 572.611 246.687 549.663 234.573 402.014L-70.064 400.737C-52.6038 613.543 603.79 690.098 1152.29 692.397Z",
    fill: "url(#paint0_linear_8765_16803)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8765_16803",
    x: -470.064,
    y: 0.737305,
    width: 2022.36,
    height: 1091.66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_8765_16803"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8765_16803",
    x1: 940.537,
    y1: 597.861,
    x2: -47.251,
    y2: 678.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2936AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraidentSubscription1);
export default __webpack_public_path__ + "static/media/graident_subscription_1.1cefd2a9ed9910eeeb7e9c7497bedc53.svg";
export { ForwardRef as ReactComponent };